import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import OrganizationGroupPages from "./OrganizationGroupPages";
import OrganizationGroupEditPage from "./OrganizationGroupPages/editPage";
import OrganizationEmployeePages from "./OrganizationEmployeePages";
import OrganizationEmployeeEditPage from "./OrganizationEmployeePages/editPage";
import OrganizationPositionPages from "./OrganizationPositionPages";
import OrganizationPositionEditPage from "./OrganizationPositionPages/editPage";

export default function OrganizationPages(props) {
  const { match } = props;
  return (
    <Switch>

      <Route
        exact
        path={`${match.url}/group`}
        component={withPermission(
          OrganizationGroupPages,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/group/:id`}
        component={withPermission(
          OrganizationGroupEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />

      <Route
        exact
        path={`${match.url}/position`}
        component={withPermission(
          OrganizationPositionPages,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/position/:id`}
        component={withPermission(
          OrganizationPositionEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />

      <Route
        exact
        path={`${match.url}/employee`}
        component={withPermission(
          OrganizationEmployeePages,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/employee/:id`}
        component={withPermission(
          OrganizationEmployeeEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}/group`} />} />
    </Switch>
  );
}
